"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookItem_1 = require("../../codebook/CodebookItem");

var FormFieldConverter_1 = require("./FormFieldConverter");

var FormField_1 = require("../FormField");
/**
 * Default implementation of FormFieldConverter.
 *
 * @author Radek Beran
 */


var FormFieldConverterImpl =
/*#__PURE__*/
function (_FormFieldConverter_) {
  _inherits(FormFieldConverterImpl, _FormFieldConverter_);

  function FormFieldConverterImpl() {
    _classCallCheck(this, FormFieldConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormFieldConverterImpl).apply(this, arguments));
  }

  _createClass(FormFieldConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new FormField_1.FormField(source.name, conversions.asObjectList(source, 'codebook', function (doc) {
        return new CodebookItem_1.CodebookItem(doc.id, doc.title);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, {
        name: source.name,
        codebook: conversions.asObjectArray(source, 'codebook', function (item) {
          return {
            id: item.id,
            title: item.title
          };
        })
      });
      return document;
    }
  }]);

  return FormFieldConverterImpl;
}(FormFieldConverter_1.FormFieldConverter);

exports.FormFieldConverterImpl = FormFieldConverterImpl;